import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-actions-vehicles',
  templateUrl: './actions-vehicles.component.html',
  styleUrls: ['./actions-vehicles.component.scss']
})
export class ActionsVehiclesComponent implements OnInit {

  @Output() configVehicle = new EventEmitter<any>();
  @Output() followVehicle = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  clickConfigVehicle(){
    console.log("============ clickConfigVehicle vehicle ==============");
    this.configVehicle.emit();
  }

  clickFollowVehicle(){
    console.log("============ clickFollowVehicle vehicle ==============");
    this.followVehicle.emit();
  }

}
